import React from 'react';
import ForecastProfitComponent from './ForecastProfitComponent';
const ForecastProfitForm = ({ formikProps, }) => {
    return React.createElement(ForecastProfitComponent, { formikProps: formikProps });
};
export default ForecastProfitForm;
